import { apiFetchV2 } from '@m/utils/http';

import type { GrpcCurrency } from '@m/types/grpc/GrpcTypes';

// prepare-save-payment-method answers 200 with an error message in `stripeClientSecret` when it
// can't create the Stripe customer (e.g. "error creating stripe customer: Invalid email address").
// Throw so callers show their load-error state instead of handing that text to Stripe.
export class InvalidStripeClientSecretError extends Error {
  constructor() {
    super('prepare-save-payment-method did not return a Stripe client secret');
    this.name = 'InvalidStripeClientSecretError';
  }
}

const assertStripeClientSecret = (stripeClientSecret: string) => {
  if (!/^(seti|pi)_.+_secret_.+$/.test(stripeClientSecret)) {
    throw new InvalidStripeClientSecretError();
  }
  return stripeClientSecret;
};

export const fetchStripeClientSecret = async (userId: number) => {
  const { stripeClientSecret } = await apiFetchV2<{ stripeClientSecret: string }>(
    `/user/${userId}/prepare-save-payment-method`,
    {
      method: 'POST',
    },
  );
  return assertStripeClientSecret(stripeClientSecret);
};

export const fetchStripeClientSecretForExpressCheckout = async (
  userId: number,
  amount: GrpcCurrency,
) => {
  const response = await apiFetchV2<{ stripeClientSecret: string }>(
    `/user/${userId}/prepare-save-payment-method`,
    {
      method: 'POST',
      body: { amount },
    },
  );

  return assertStripeClientSecret(response.stripeClientSecret);
};
